import { render, staticRenderFns } from "./OptimizationOpportunities.vue?vue&type=template&id=849b1bee&"
import script from "./OptimizationOpportunities.vue?vue&type=script&lang=js&"
export * from "./OptimizationOpportunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports